<template>
    <div class="all">
        <!-- 筛选 -->
        <div class="screen clearfix" v-if="$route.query.planId == undefined">
            <div class="fl">
                <div class="corm fr clearfix">
                    <a class="element" :class="{curr:pattern === 1}" href="javascript:void(0);" @click="patternTab(1);">标准模式</a>
                    <a class="element" :class="{curr:pattern === 2}" href="javascript:void(0);" @click="patternTab(2);">高级模式</a>
                </div>
            </div>
        </div>
        <div class="warp" :class="{mt20:$route.query.planId == undefined}">
            <div class="warp-header">
                <h2>设置方案</h2>
            </div>
            <div class="warp-body clearfix">
                <!-- 建方案 -->
                <div class="form-warp input-list fl">
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red">*</i> 方案名称:</span>
                        <div class="input-father"><input class="input-text" maxlength="10" v-model.trim="name" type="text" placeholder="请输入方案名称"/></div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red">*</i> 所属分类:</span>
                        <div class="fl clearfix">
                            <span class="drop-down">
                                <button class="btn btn-lightblue"><span class="text">{{typeId !='' ? typeName : '选择方案分类'}}</span><i class="icons"></i></button>
                                <ul class="option">
                                    <li class="ovhidden" v-for="(item,index) in planClassification.schemeTypeList" @click="selectPlan(item.id);" :key="index">{{item.name}}</li>
                                </ul>
                            </span>
                            <button class="btn btns" v-if="$parent.uid == ownerUserId||ownerUserId == ''" @click="addPlanClassification();"><i class="icons add-icon1"></i><span class="color-blue">添加分类</span></button>
                        </div>
                    </div>
                    <h4 class="mt30">分析词设置（必填）</h4>
                    <div class="item clearfix" style="margin-top:15px;">
					    <span class="name fl">地域词:</span>
					    <div class="input-father no-hidden clearfix">
                            <div class="areas-add">
                                <city class="city-select fl" ref="cityWarp" @cityCallback="citySelect" levels="3"></city>
                                <button class="btn btns"><i class="icons add-icon1"></i><span class="color-blue">添加地区</span></button>
                            </div>
					        <!-- 地区选择 -->
                            <div class="areas">
                                <span class="signs sign-lightblue" v-for="(item,index) in contentArea" :key="index">{{item}}<a class="cha color-blue" @click="delArea(index);" href="javascript:void(0);">&times;</a></span>
                            </div>
					    </div>
					</div>
                    <div class="item clearfix">
                        <span class="name fl"> 主体词:</span>
                        <div class="input-father no-hidden clearfix">
                            <div class="input-item">
                                <input class="input-text" v-model.trim="bodyInput" type="text" @keyup="bodyWordWirte();" placeholder="输入主体词，多个词用,隔开"/>
                            </div>
                            <div class="grid-info fr tips">
                                <i class="icons icons-question-circle"></i>
                                <p class="grid-tip">主体词一般为人物、品牌、机构名，和行业分类/分析词之间为“与”关系</p>
                            </div>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl"><i class="color-red"></i> 行业分类:</span>
                        <div class="fl clearfix">
                            <span class="drop-down1">
                                <button class="btn btn-lightblue" @click="openSelect"><span class="text">{{industryName !=='' ? industryName : '选择行业分类'}}</span><i class="icons"></i></button>
                            </span>
                        </div>
                        <div class="d-flex yichild">
                            <div class="yixuan" v-for="(item,index) in platformchildArr" :key="index">{{item.name}} <span @click="delplatformchildArr(item);" style="cursor: pointer;">&times;</span></div>
                        </div>
                    </div>
                    <div class="item mt25">
                        <!-- 标准模式 -->
                        <div class="clearfix" v-if="pattern === 1">
                            <span class="name fl"> 分析词:</span>
                            <div class="input-father">
                                <div class="input-item" v-for="(item,index) in monitorInput" :key="index">
                                    <input class="input-text" v-model.trim="monitorPlanArr[index]" type="text" @keyup="monitorWordWirte(index);" placeholder="输入分析关键词，多个词用,隔开"/>
                                    <i class="del" v-if="monitorInput.length > 1" @click="delMonitorInput(index);">&times;</i>
                                </div>
                                <div class="mt10 clearfix">
                                    <button class="btn btns fl" @click="addMonitorInput();"><i class="icons add-icon1"></i><span class="color-blue">添加“或”的关键词</span></button>
                                    <p class="input-tips fr">（每组分析词是或的关系，最多支持10个关键词）</p>
                                </div>
                            </div>
                        </div>
                        <!-- 高级模式 -->
                        <div class="clearfix" v-if="pattern === 2">
                            <span class="name fl"> 分析词:</span>
                            <div class="input-father no-hidden">
                                <div class="clearfix">
                                    <div class="tool-group fl">
                                        <button class="btn" @click="addMonitorSymbol('+');">+</button>
                                        <button class="btn" @click="addMonitorSymbol('|');">|</button>
                                        <button class="btn" @click="addMonitorSymbol('()');">( )</button>
                                        <button class="btn btn-blue" @click="seniorPreview();">预览</button>
                                    </div>
                                    <div class="grid-info fr tips1">
                                        <i class="icons icons-question-circle"></i>
                                        <p class="grid-tip">+号表示与关系，|号表示或关系。示例：华为+（手机 | 充电器+数据线），需要监测的数据即为包含华为+手机，或者包含华为+充电器+数据线的文章</p>
                                    </div>
                                </div>
                                <textarea class="input-textarea h174 mt10" ref="seniorTextarea" v-model.trim="seniorMonitor" @keyup="monitorPlanArrWrite();" name="" placeholder="输入关联监测词"></textarea>
                            </div>
                        </div>
                    </div>
                    <!-- 词间距 -->
                    <div class="block" v-if="wordSpacingAuthority == 1">
                        <span class="demonstration">词间距</span>
                        <div class="fr">
                            <span class="switch" :class="status == 1 ? 'active' : ''" @click="oneButtonSwitch();">词间距开关 <i class="icons switch-icon"></i></span>
                        </div>
                        <el-slider :show-tooltip="false" v-model="wordSpacingSlop" :min="0" :max="wordSpacingSlopMax"></el-slider>
                    </div>
                    <div class="item clearfix por">
                        <span class="name fl"><i class="color-red">*</i> 内容分类</span>
                        <div class="grid-info build-content">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">信息监测的文本内容具有不同的分类，可根据监测需要选择对应的类型</p>
                        </div>
                        <div class="input-father infor-match-check mt30 ml100">
                            <el-checkbox class="mb10" v-model="checkAll" @change="handleCheckAllChange" border size="small">全部</el-checkbox>
                            <el-checkbox-group v-model="checkList" @change="handleCheckedChange">
                                <el-checkbox v-for="(item,index) in articleTypeList" :key="index" :label="item.name" border size="small">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                    <h4 class="mt20">特征词设置（选填）</h4>
                    <div class="item mt15 clearfix">
                        <span class="name fl">歧义词:</span>
                        <div class="input-father">
                            <textarea class="input-textarea h174" ref="seniorTextarea" v-model.trim="ambiguousWords" @keyup="ambiguousWordsWrite();" name="" placeholder="输入歧义词，多个词用,隔开，最多支持50个关键词"></textarea>
                            <div class="clearfix">
                                <p class="input-tips fr">（例：分析词为清华大学，歧义词设置为清华大学生，清华大学生将不会再进行高亮）</p>
                            </div>
                        </div>
                    </div>
                    <div class="item clearfix">
                        <span class="name fl">排除词:</span>
                        <div class="input-father">
                            <textarea class="input-textarea h174" ref="seniorTextarea" v-model.trim="excludeWord" @keyup="excludeWordsWrite();" name="" placeholder="输入排除词，多个词用,隔开"></textarea>
                            <div class="clearfix">
                                <p class="input-tips fr">（包含排除词的信息将不会进入分析结果）</p>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="item clearfix">
                        <span class="name fl">负面词:</span>
                        <div class="input-father">
                            <input class="input-text" type="text" @keyup="negativeWordWrite();" v-model="negativeWord" placeholder="输入负面词，多个词用,隔开，最多支持10个关键词"/>
                            <div class="clearfix">
                                <p class="input-tips fr">（符合负面词的信息为负面信息）</p>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-btn">
                        <button class="btn save btn-jbblue" @click="planSave();">保存</button>
                    </div>
                </div>
                <!-- 方案预览 -->
                <div class="examine w300 fl">
                    <div class="examine-header">
                        <h4>方案预览</h4>
                    </div>
                    <div class="examine-body">
                        <ul v-if="pattern === 1" class="maxH500">
                            <li v-for="(item,index) in planArr" class="ovhidden" :key="index">{{index+1}}. {{item}}</li>
                        </ul>
                        <ul v-if="pattern === 2" class="maxH500">
                            <li v-for="(item,index) in seniorPlanArr" class="ovhidden" :key="index">{{index+1}}. {{item}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 查看分析词 -->
        <Dialog ref="shieldAnaModalFn" width="550" :title="'行业词库'" :modalFoot="false">
            <div slot="mdBox">
                <div class="d-flex dioFenxi">
                    <div class="left_">
                        <el-tree
                        ref="myTree"
                        :data="MediaPlatformList"
                        :show-checkbox='true'
                        node-key="id"
                        :default-expanded-keys="expandedkeys"
                        :default-checked-keys="checkedkeys"
                        :props="defaultProps"
                        @check-change="getfenleiList">
                        </el-tree>
                    </div>
                    <div class="right_">
                        <div class="pd" v-if="analysisList.length===0">请选择行业分类</div>
                        <div v-else class="pd d-flex" style="flex-wrap:wrap">
                            <div class="anaList" v-for="(item,index) in analysisList" :key="index">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <!-- 添加方案 -->
        <Dialog ref="shieldModalFn" :callback="shieldModal" width="400">
            <div slot="mdBox">
                <input class="input-text" v-model="planNameType" maxlength="7" id="planName" type="text" placeholder="请输入分类名称（最多7个字）"/>
            </div>
        </Dialog>
        <!-- 添加方案 -->
        <Dialog ref="errorAlert" type="alert">
            <div slot="mdBox">
                <h3>以下标红处有错误:</h3>
                <p class="mt10" v-html="seniorMonitorHtml"></p>
            </div>
        </Dialog>
        <!-- 保存提示 -->
        <Dialog ref="savePlanModal" :callback="enterSavePlan" type="confirm">
            <div slot="mdBox">
                <p class="ac">保存成功，将会自动切换为新的分析方案</p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import city from '../../components/city.vue';
import {mapState} from 'vuex';
export default {
    components:{Dialog,city},
    computed:{
        ...mapState({
            companyinfo: state => state.show.companyinfo,
        })
    },
    data() {
        return {
            status:-1,
            wordSpacingSlopMax:30, // 词间距设置最大值
            wordSpacingAuthority:'',  //是否有词间距功能
            wordSpacingSlopSwitch:-1, // 词间距开关
            wordSpacingSlop:0, //词间距
            defaultProps: {
                children: 'secondary',
                label: 'name'
            },
            expandedkeys:[],//默认展开的节点的 key 的数组
            checkedkeys:[],//默认勾选的节点的 key 的数组
            pattern:1,//1是标准模式 2是高级模式
            name:'',//方案名称
            saveType:0,//方案保存方式 0是新增 2是编辑
            planNameType:'',//添加的方案分类
            planClassification:[],//方案分类
			contentArea:[],//地区
            planNum:0,
            planId:'',//方案ID
            typeId:'',//选择的方案分类ID
            typeName:'',//选择的方案分类名
            monitorInput:['plan0'],//分析词框个数
            bodyInput:'',//主体词
            bodyPlanArr:[],//主体词数组
            planArr:[],//方案预览数组
            seniorPlanArr:[],//高级的预览分析词
            monitorPlanArr:[],//分析词数组
            seniorMonitor:'',//高级模式分析词
            seniorMonitorHtml:'',//标红的高级模式分析词
            ambiguousWords:'',//歧义词
            excludeWord:'',//排除词
            negativeWord:'',//负面词
            industryName:'',//行业名字
            analysisList:[],//行业分析词列表
            MediaPlatformList:[],
            platformchildType:[],//行业分析二级目录数组
            platformchild:'',//行业分析二级目录
            platformchildArr:[],//行业分析二级目录集合
            keywordsMain:[],
            keywordsFinal:[],
            currentnodekey:'',
            articleTypeList:[], //内容分类数据
            checkAll:true, //全选
            checkList:['全部'],
            ownerUserId:'',
            industrylist:[],
            newsContentField:[]
        }
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.getEditPlaninformation();
            let data = that.companyinfo;
            let arr = data.articleTypeList;
            this.articleTypeList = arr.filter(item=>{
                return item.name !== '全部'
            })
            this.wordSpacingSlopMax = data.wordSpacingSlopMax;
            this.wordSpacingAuthority = data.wordSpacingAuthority;
        })
    },
    created() {

    },
    methods: {
        // 全选
        handleCheckAllChange(val) {
            if(val) {
                let arr = []
                this.articleTypeList.forEach((item)=>{
                    arr.push(item.name)
                })
                this.checkList = arr
            }else {
                this.checkList = []
            }
        },
        // 内容分类选中
        handleCheckedChange(value) {
            if(value && value.length > 0) { // 与全选互斥
                this.checkAll = false
                let data = JSON.parse(JSON.stringify(value))
                if(data[0] === '全部') {
                    data = data.slice(1)
                }
                this.checkList = data
                let arr =[]
                this.articleTypeList.forEach(item=>{
                    arr.push(item.name)
                })
                if(this.checkList.length === arr.length) {
                    this.checkAll = true
                }
            }else {
                this.checkList = []
            }
        },
        // 删除内容分类
        delCheckList(item) {
            if(item) {
                let index = this.checkList.findIndex(value=>{
                    return value === item
                })
                this.checkList.splice(index,1)
                this.checkAll = false
            }else {
                this.checkList = []
                this.checkAll = false
            }
        },
        oneButtonSwitch(){
            if(this.status == 1){
                this.status = -1
                this.wordSpacingSlopSwitch = -1
            }else{
                this.status = 1
                this.wordSpacingSlopSwitch = 1
            }
        },
        //获取行业子分类
        getfenleiList(e1,e2,e3){
            let list = this.platformchildArr;
            // console.log(this.$refs.myTree.getCheckedNodes(true,false))
            this.platformchildArr = this.$refs.myTree.getCheckedNodes(true,false);
            if(this.platformchildArr.length>0){
                this.selectIndustry();
            }else{
                this.analysisList = [];
            }

        },
        //选择行业分类
        selectIndustry(){
            let that = this;
            this.checkedkeys = [];
            let industryTypeSecondary = '';
            for(let item of this.platformchildArr){
                this.checkedkeys.push(item.id);
                industryTypeSecondary+=item.id +',';
            }
            that.$api.get('monitor/scheme/industry-type-words',{industryTypeSecondary:industryTypeSecondary},r =>{
                that.$utils.returnCode(r,function(){
                    let data = r.data;
                    that.analysisList = data;
                });
            })
        },
        //打开行业选择
        openSelect(){
            //this.optionShow = !this.optionShow;
            this.$refs.shieldAnaModalFn.showMaskFun();
        },
        //取消行业分类
        cancelIndustry(){
            this.analysisList = []
        },
        //查看行业分析词
        watchIndustry(){
            if(this.industryName === ''){
                this.$utils.alertText('请选择行业');
                return false;
            }
            this.$refs.shieldAnaModalFn.showMaskFun();
        },
        // 模式切换
        patternTab (type) {
            this.pattern = type;
        },
        // 获取编辑方案信息
        getEditPlaninformation () {
            let that = this;
            let id = that.$route.query.planId;
            if(id != undefined){
                that.$parent.loadModal(true,'正在获取数据...');
                that.$api.get('monitor/scheme/info',{id:id},r =>{
                    that.$utils.returnCode(r,function(){
                        that.$parent.showLoad = false;
                        let data = r.data;
                        let monitorInput = [];
                        that.ownerUserId = data.owner_user_id;
                        //获取行业分类
                        that.industrylist = data.industryTypeSecondary.split(',');
                        that.newsContentField = data.newsContentField;
                        that.getPlanClassification();
                        that.wordSpacingSlopSwitch = data.wordSpacingSlopSwitch
                        that.status = that.wordSpacingSlopSwitch
                        that.wordSpacingSlop = data.wordSpacingSlop == 0?1:data.wordSpacingSlop;
                        that.saveType = 1;
                        that.typeId = data.typeId;

                        that.planId = data.id;
                        that.contentArea = data.contentArea;//地区
						            that.$refs.cityWarp.fullName = data.contentArea[0],
                        that.name = data.name;
                        if(data.keywordsInit.length>0){
                            for(let i = 0;i < data.keywordsInit.length;i++){
                                that.planNum++;
                                let plan = 'plan' + that.planNum;
                                monitorInput.push(plan);
                            }
                        }else{
                            monitorInput=['plan0']
                        }
                        that.monitorInput = monitorInput;
                        that.monitorPlanArr = data.keywordsInit;
                        that.seniorMonitor = data.keywordsInit;
                        that.pattern = data.createMode;
                        that.keywordsMain = data.keywordsMain;
                        that.keywordsFinal = data.keywordsFinal;
                        if(data.keywordsFinal.length>0&&data.keywordsMain.length>0){
                            for(let item of data.keywordsFinal){
                                for(let items of data.keywordsMain){
                                    that.planArr.push(`${items} + ${item}`)
                                }
                            }
                        } else if(data.keywordsFinal.length>0&&data.keywordsMain.length==0){
                            for(let item of data.keywordsFinal){
                                that.planArr.push(`${item}`)
                            }
                        }else{
                            for(let item of data.keywordsMain){
                                that.planArr.push(`${item}`)
                            }
                        }
                        that.ambiguousWords = data.keywordsAmbiguous;
                        that.excludeWord = data.keywordsExclude;
                        if(data.keywordsMain.length>0){
                            for(let item of data.keywordsMain){
                                that.bodyInput += `${item},`;
                            }
                            that.bodyInput = that.bodyInput.substr(0,that.bodyInput.length-1);
                        }else{
                            that.bodyInput = '';
                        }
                    });
                })
            } else {
              that.getPlanClassification();
            }
        },
        //获取方案分类
        getPlanClassification () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('monitor/scheme-type/list',{uid:this.ownerUserId},r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.planClassification = data;
                    that.MediaPlatformList=data.industryTypeList;
                    for(let j of that.planClassification.schemeTypeList){
                        if(that.typeId == j.id){
                            that.typeName = j.name;
                        }
                    }
                    let allIndustrylist = [];
                    for(let child of that.MediaPlatformList){
                        allIndustrylist=allIndustrylist.concat(child.secondary);
                    }
                    for(let item of that.industrylist){
                        for(let items of allIndustrylist){
                            if(item == items.id){
                                that.platformchildArr.push(items);
                            }
                        }
                    }
                    if(that.newsContentField.length===0||that.newsContentField[0] == '全部'){
                        that.checkAll = true;
                        that.checkList = [];
                    }else{
                        that.checkAll = false;
                        that.checkList = that.newsContentField
                    }
                    if(that.platformchildArr.length>0){
                        that.selectIndustry();
                    }
                });
            })
        },
		// 地区筛选
		citySelect (name) {
		    let province = name;
            let that = this;
            if(that.contentArea.indexOf(province) != -1){
                return;
            }
		    that.contentArea.push(province);
		},
		//清空地区
		delArea (index){
            // let area = this.contentArea;
            this.contentArea.splice(index,1);
		},
        //选择方案
        selectPlan (id) {
            this.typeId = id;
        },
        // 添加方案分类
        addPlanClassification () {
            let that = this;
            that.$refs.shieldModalFn.showMaskFun();
        },
        // 确认添加方案分类
        shieldModal () {
            let that = this;
            if(that.planNameType == ''){
                that.$utils.alertText('方案分类不能为空');
                return;
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/scheme-type/create',{name:that.planNameType},r =>{
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    that.planClassification.schemeTypeList.push(data);
                    that.planNameType = '';
                    that.$refs.shieldModalFn.closeMask();
                    that.$utils.alertText('新增成功');
                    that.$store.dispatch('show/changeToast',{text:'新增成功'})
                });
            });
        },
        //添加分析词输入框
        addMonitorInput () {
            let that = this;
            let monitorInput = that.monitorInput;
            if(monitorInput.length >= 10){
                that.$utils.alertText('分析词最多添加10组',200);
                return;
            }
            that.planNum++;
            let plan = 'plan' + that.planNum;
            monitorInput.push(plan);
        },
        // 分析词符号添加
        addMonitorSymbol (content) {
            // that.seniorMonitor
            let textarea = this.$refs.seniorTextarea;
            let startPos = textarea.selectionStart;
            let endPos = textarea.selectionEnd;
            if (startPos === undefined || endPos === undefined) {
               return;
            }
            let txt = textarea.value;
            let result = txt.substring(0, startPos) + content + txt.substring(endPos)
            this.seniorMonitor = result;
            textarea.focus();
        },
        // 高级模式的分析词输入替换中文括号
        monitorPlanArrWrite () {
            let seniorMonitor = this.seniorMonitor;
            seniorMonitor = seniorMonitor.replace(/（/g, '(');
            seniorMonitor = seniorMonitor.replace(/）/g, ')');
            this.seniorMonitor = seniorMonitor;
        },
        // 分析词输入
        monitorWordWirte (index) {
            let that = this;
            let monitorPlanArr = that.monitorPlanArr;//分析词数组
            let str = that.monitorPlanArr[index];
            if(index != undefined){
                if(str != undefined){
                    //中文逗号转英文
                    str = str.replace(/，/g, ",");
                    str = str.replace(/\+/g, ',');
                    str = str.replace(/,,/g, ',');
                    if (str.substr(0,1)===','){
                        str=str.substr(1);
                    }
                    // let len = (monitorPlanArr[index].match(/,/g)||[]).length;
                    // // if(len >= 10){
                    // //     let reg=/,$/gi;
                    // //     str=str.replace(reg,"");
                    // // }
                }
                that.monitorPlanArr[index] = str;
            }
            let arr = [];
            for(let i of monitorPlanArr){
                let news = '';
                if(i != undefined){
                    let val = i.split(',');
                    for(let j of val){
                        news += j + '+'
                    }
                    arr.push(news.substr(0, news.length - 1));
                }
            }
            arr = arr.filter(item => item)
            that.planArr = arr;
            let planList = [];
            that.keywordsFinal = arr;
            if(that.keywordsMain&&that.keywordsMain.length>0&&that.keywordsFinal&&that.keywordsFinal.length>0){
                for(let item of arr){
                    for(let items of that.keywordsMain){
                        planList.push(`${items} + ${item}`)
                    }
                }
            }else if(that.keywordsMain&&that.keywordsMain.length>0&&that.keywordsFinal&&that.keywordsFinal.length===0){
                planList = that.keywordsMain;
            }else if(that.keywordsMain&&that.keywordsMain.length===0&&that.keywordsFinal&&that.keywordsFinal.length>0){
                planList = that.keywordsFinal;
            }else{
                planList = [];
            }
            that.planArr = planList;
        },
        bodyWordWirte(e){
            let that = this;
            let str = that.bodyInput;
            //中文逗号转英文
            str = str.replace(/，/g, ",");
            str = str.replace(/\+/g, ',');
            str = str.replace(/,,/g, ',');
            if (str.substr(0,1)===','){
                str=str.substr(1);
            }
            that.bodyInput = str;
            if(that.bodyInput != ''){
                that.keywordsMain = that.bodyInput.split(',');
            }else{
                that.keywordsMain = [];
            }
            let planListarr = [];
            if(that.keywordsFinal&&that.keywordsFinal.length>0&&that.keywordsMain&&that.keywordsMain.length>0){
                for(let item of that.keywordsFinal){
                        for(let items of that.keywordsMain){
                            planListarr.push(`${items} + ${item}`);
                        }
                    }
            }else if(that.keywordsFinal&&that.keywordsFinal.length>0&&that.keywordsMain&&that.keywordsMain.length===0){
                planListarr = that.keywordsFinal;

            }else if(that.keywordsFinal&&that.keywordsFinal.length===0&&that.keywordsMain&&that.keywordsMain.length>0){
                planListarr = that.keywordsMain;
            }else{
                planListarr = [];
            }
            that.planArr = planListarr;
        },
        //主体词输入框删除
        delBodyInput (index) {
            let that = this;
            let bodyInput = that.bodyInput;
            bodyInput.splice(index,1);
            that.bodyPlanArr.splice(index,1);
            that.bodyWordWirte();
        },
        //分析词输入框删除
        delMonitorInput (index) {
            let that = this;
            let monitorInput = that.monitorInput;
            monitorInput.splice(index,1);
            that.monitorPlanArr.splice(index,1);
            that.monitorWordWirte();
        },
        //歧义词输入
        ambiguousWordsWrite () {
            let that = this;
            let ambiguousWords = that.ambiguousWords;
            if(ambiguousWords != ''){
                let ambiguousWords1 = '';
                //中文逗号转英文
                ambiguousWords1 = ambiguousWords.replace(/，/g,",");
                that.ambiguousWords = ambiguousWords1;
                // 获取第一个字符
                let frist = that.ambiguousWords[0]
                //去除连续,
                let pattern = /\,{2}/;//去除连续正则
                let len = (ambiguousWords.match(/,/g)||[]).length;
                if(len >= 50 || pattern.test(that.ambiguousWords) || frist === ','){//判断分析词个数和连续,
                    ambiguousWords1 = ambiguousWords.substr(0, ambiguousWords.length - 1);
                    that.ambiguousWords = ambiguousWords1;
                }
            }
        },
        //排除词输入
        excludeWordsWrite () {
            let that = this;
            let excludeWord = that.excludeWord;
            let excludeWord1 = '';
            if(excludeWord != ''){
                //中文逗号转英文
                excludeWord1 = excludeWord.replace(/，/g,",");
                that.excludeWord = excludeWord1;
                // 获取第一个字符
                let frist = that.excludeWord[0]
                //去除连续,
                let pattern = /\,{2}/;//去除连续正则
                let len = (excludeWord.match(/,/g)||[]).length;
                if(len >= 10000 || pattern.test(that.excludeWord) || frist === ','){//判断分析词个数和连续,
                    excludeWord1 = excludeWord.substr(0, excludeWord.length - 1);
                    that.excludeWord = excludeWord1;
                }
            }
        },
        //负面词输入
        negativeWordWrite () {
            let that = this;
            let negativeWord = that.negativeWord;
            let negativeWord1 = '';
            //中文逗号转英文
            negativeWord1 = negativeWord.replace(/，/g,",");
            that.negativeWord = negativeWord1;
            // 获取第一个字符
            let frist = that.negativeWord[0]
            //去除连续,
            let pattern = /\,{2}/;//去除连续正则
            let len = (negativeWord.match(/,/g)||[]).length;
            if(len >= 10 || pattern.test(that.negativeWord) || frist === ','){//判断分析词个数和连续,
                negativeWord1 = negativeWord.substr(0, negativeWord.length - 1);
                that.negativeWord = negativeWord1;
            }
        },
        // 预览高级分析词
        seniorPreview() {
            let that = this;
            let reg = new RegExp(/^(\+|\|)|\+{2}|\|{2}|\({2}|\+\||\|\+|\(\+|\+\)|\(\||\|\)|\([^\)]*\(|\)[^\(]*\)|\)\(|\(\s*\)|[^\+\|]\(|\)[^\+\|]|(\+|\|)$/g);
            if(that.seniorMonitor === ''&&that.bodyInput === ''){
                that.$utils.alertText('请输入分析词或主体词后在预览');
                return;
            }else if(reg.test(that.seniorMonitor)){//高级模式校验分析词
                that.seniorMonitorError(that.seniorMonitor);
                return;
            }
            that.$parent.loadModal(true,'请稍后...');
            that.$api.post('monitor/scheme/keywords-preview', {keywords:that.seniorMonitor,keywordsMain:that.bodyInput}, r=> {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.seniorPlanArr = r.data.previewKeywords;
                });
            })
        },
        // 分析词检测标红提示
        seniorMonitorError(value) {
            let that = this;
            let patterns = /^(\+|\|)|\+{2}|\|{2}|\({2}|\+\||\|\+|\(\+|\+\)|\(\||\|\)|\([^\)]*\(|\)[^\(]*\)|\)\(|\(\s*\)|[^\+\|]\(|\)[^\+\|]|(\+|\|)$/g;
                if(!patterns.test(value)) {

                } else {
                    let index = patterns.lastIndex;
                    let text = '';
                    if(index === 1){
                       text = value.slice(index-1,index+1);
                    }else{
                        text = value.slice(index-2,index+1);
                    }
                    let html = '<i class="color-red">'+text+'</i>'
                    let start = value.substring(0,index-2);
                    let end = value.substring(index+1,value.length);
                    that.seniorMonitorHtml = start+html+end;
                    that.$refs.errorAlert.showMaskFun();
                }
        },
        //方案保存
        planSave () {
            let that = this;
            // if(that.isDisable == true){//防止重复提交
            //     return;
            // }
            if(this.platformchild == ''){
                this.industryId = '';
            }
            let reg = new RegExp(/^(\+|\|)|\+{2}|\|{2}|\({2}|\+\||\|\+|\(\+|\+\)|\(\||\|\)|\([^\)]*\(|\)[^\(]*\)|\)\(|\(\s*\)|[^\+\|]\(|\)[^\+\|]|(\+|\|)$/g);
            if(that.name == ''){
                that.$utils.alertText('方案名称不能为空',200);
                return;
            }else if(that.typeId == ''){
                that.$utils.alertText('请选择方案分类',200);
                return;
            }else if(that.pattern === 1 && (that.monitorPlanArr == ''&&this.platformchildArr.length<=0&&that.bodyInput == '')){
                that.$utils.alertText('分析关键词或行业分类或主体词不能为空',280);
                return;
            }else if(that.pattern === 2 && reg.test(that.seniorMonitor)){//高级模式校验分析词
                that.seniorMonitorError(that.seniorMonitor);
                // that.$utils.alertText('分析关键词格式错误',200);
                return;
            }
            that.$refs.savePlanModal.showMaskFun();
        },
        //确认保存方案
        enterSavePlan () {
            this.checkedkeys = [];
            let industryTypeSecondary = '';
            let frontEndIndustryType = [];
            for(let item of this.platformchildArr){
                industryTypeSecondary+=item.id +',';
                for(let items of this.MediaPlatformList){
                    for(let obj of items.secondary){
                        if(item.id == obj.id){
                            frontEndIndustryType.push(`${items.name}-${item.name}`)
                        }
                    }
                }
            }
            industryTypeSecondary=industryTypeSecondary.substr(0, industryTypeSecondary.length - 1);
            //console.log(frontEndIndustryType)
            let that = this;
            let type = that.saveType;
            let pattern = that.pattern;
            let monitor = '';//分析词变量
            if(pattern === 1){//标准
                monitor = that.monitorPlanArr;
            }else if(pattern === 2){//高级
                monitor = that.seniorMonitor;
            }
            if(monitor.length===0){
                monitor = '';
            }
            let url = '';
            let datas = '';
            if(type === 0){//新增保存
                url = 'monitor/scheme/create';
                datas = {
                    createMode:pattern,
					contentArea:that.contentArea,//地区
                    name:that.name,
                    typeId:that.typeId,
                    keywordsFinal:monitor,
                    keywordsAmbiguous:that.ambiguousWords,
                    keywordsExclude:that.excludeWord,
                    frontEndIndustryType:frontEndIndustryType,
                    industryTypeSecondary:industryTypeSecondary,
                    keywordsMain:that.bodyInput,
                    wordSpacingSlop:that.wordSpacingSlop,
                    wordSpacingSlopSwitch:that.wordSpacingSlopSwitch,
                    newsContentField:that.checkList.length == that.articleTypeList.length||that.checkAll?['全部']:that.checkList
                };
            }else if(type === 1){//编辑保存
                url = 'monitor/scheme/update';
                datas = {
                    createMode:pattern,
					contentArea:that.contentArea,//地区
                    name:that.name,
                    typeId:that.typeId,
                    id:that.planId,
                    keywordsFinal:monitor,
                    keywordsAmbiguous:that.ambiguousWords,
                    keywordsExclude:that.excludeWord,
                    frontEndIndustryType:frontEndIndustryType,
                    industryTypeSecondary:industryTypeSecondary,
                    keywordsMain:that.bodyInput,
                    wordSpacingSlop:that.wordSpacingSlop,
                    wordSpacingSlopSwitch:that.wordSpacingSlopSwitch,
                    newsContentField:that.checkList.length == that.articleTypeList.length||that.checkAll?['全部']:that.checkList
                };
            }
            that.$refs.savePlanModal.closeMask();
            if(datas.newsContentField.length === 0){
                that.$utils.alertText('请选择内容分类');
                return false;
            }
            that.$parent.loadModal(true,'正在提交数据');
            that.$api.post(url, {data:datas}, r=> {
                that.$utils.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    let data = r.data;
                    data.keywordsMain = data.keywordsMain.split(',');
                    data.keywordsMainSelect = data.keywordsMainSelect.split(',');
                    that.resetSetItem('planStorage', JSON.stringify(data));
                    that.$parent.isPlan = data;
                    that.$parent.getCurrplan();
                    that.$router.push({path:''+'./yuYingGather'});
                },function(){
                    that.$parent.showLoad = false;
                })
            })
        },
        //直接删除二级行业分类
        delplatformchildArr(item){
            for(let i = 0 ; this.platformchildArr.length>i ; i++){
                if(this.platformchildArr[i].id == item.id){
                    this.platformchildArr.splice(i,1);
                }
            }
            if(this.platformchildArr.length>0){
                this.selectIndustry();
            }
        }
	},
    watch: {
        $route(){
            let that = this;
            let id = that.$route.query.planId;//获取当前页面url的type
            if(id != undefined){
                that.platformchildType=[]//行业分析二级目录数组
                that.platformchild=''//行业分析二级目录
                that.platformchildArr=[]//行业分析二级目录集合
                that.analysisList=[]//行业分析词列表
                that.checkedkeys = []
                that.bodyInput = ''
                that.ownerUserId = id
                that.getEditPlaninformation();
            }else{
                that.name = ''//方案名称
				that.contentArea = []//地区
                that.saveType = 0//方案保存方式 0是新增 2是编辑
                that.planNum = 0
                that.planId = ''//方案ID
                that.seniorMonitor = ''//高级模式的分析词
                that.typeId = ''//选择的方案分类ID
                that.monitorInput = ['plan0']//分析词框个数
                that.planArr = []//方案预览数组
                that.monitorPlanArr = []//分析词数组
                that.ambiguousWords = ''//歧义词
                that.excludeWord = ''//排除词
                that.negativeWord = ''//负面词
                that.bodyInput = ''
                that.platformchildType=[]//行业分析二级目录数组
                that.platformchild=''//行业分析二级目录
                that.platformchildArr=[]//行业分析二级目录集合
                that.analysisList=[]//行业分析词列表
                that.keywordsFinal = []
                that.keywordsMain = []
                that.industryName = ''
                that.checkedkeys = []
                that.ownerUserId = ''
                that.industrylist = []
                that.newsContentField=[]
            }
        },
        currentnodekey:{
            handler(){

            }
        }
    }
}
</script>
<style scoped>
    .dioFenxi{border:1px solid #ddd;}
    .dioFenxi .left_{
        height:300px;overflow:auto;width:170px;border-right:1px solid #ddd;padding-left:10px;
    }
    .dioFenxi .right_{
        height:300px;overflow:auto;width:330px;
    }
    .yixuan{
        padding:3px 5px;margin:5px 5px 5px 0;background:rgba(0,149,235,.1);color:#0095eb
    }
    .yichild{
        clear:both;padding-left:100px;flex-wrap:wrap;
    }
</style>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/buildSolution.vue